import type { InvoiceEvent } from '@features/invoices/types/invoices/invoiceEvent'
import { isEInvoiceSentEvent } from '@features/invoices/utils/eInvoices/isEInvoiceSentEvent'

export const hasEInvoiceSentEvent = (events: InvoiceEvent[]): boolean => events.some(isEInvoiceSentEvent)
